import {
  Breadcrumbs,
  Inline,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useEmployee, useEmployments } from '@omnipresentgroup/domains';
import { EmploymentsList } from '@omnipresentgroup/features';
import { useNavigate, useParams } from 'react-router';

import { environment } from '../../../../environment';
import { EMPLOYEE_DETAILS_PATH } from '../../../constants';

const PAGE_TITLE = 'Employments';

export const EmployeeEmployments = () => {
  const navigate = useNavigate();
  const { employeeId } = useParams();

  const { data: employee, isLoading: isLoadingEmployee } = useEmployee({
    id: employeeId,
    enabled: !!employeeId,
  });

  const {
    data: employments,
    isLoading: isLoadingEmployments,
    isError: isErrorEmployments,
  } = useEmployments({
    userId: employee?.userId || '',
    display: 'lspName',
    enabled: Boolean(employee?.userId),
  });

  const PageHeader = () => (
    <Inline justify="space-between" minH={40} align="center">
      <Inline gap="8" align="center">
        <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
          {PAGE_TITLE}
        </Typography>
      </Inline>
    </Inline>
  );

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            { id: 'home', title: 'Home', onClick: () => navigate('/') },
            {
              id: 'employee-details',
              title: `Employee details | ${
                employee?.personalDetails
                  ? `${employee?.personalDetails.firstName} ${employee?.personalDetails.lastName}`
                  : ''
              }`,
              onClick: () => {
                window.location.href = `${
                  environment.apps.OMNIPLATFORM
                }${EMPLOYEE_DETAILS_PATH(employeeId)}`;
              },
            },
            {
              id: 'employee-employments',
              title: PAGE_TITLE,
              active: true,
            },
          ]}
        />
        <PageHeader />
      </Stack>

      {employeeId && (
        <EmploymentsList
          data={employments}
          isLoading={isLoadingEmployee || isLoadingEmployments}
          isError={isErrorEmployments}
          showHeader={false}
          columnVisibility={{
            startDate: true,
            terminationDate: true,
            status: true,
            legalEntityId: true,
            type: true,
            firstPayrollDate: true,
            lastPayrollDate: true,
            actions: false,
          }}
        />
      )}
    </>
  );
};
